import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomeLight from './pages/HomeLight';
import HomeRetarget from './pages/HomeRetarget'; // Import de la nouvelle page
import MentionsLegales from './pages/MentionsLegales';
import PolitiqueConfidentialite from './pages/PolitiqueConfidentialite';
import CGU from './pages/CGU';
import Cookies from './pages/Cookies';
import Merci from './pages/Merci';
import FormPage from './pages/FormPage'; // Import de la nouvelle page
import CookieConsent from './components/CookieConsent';
import posthog, { initPostHog } from './services/posthog';
import './App.css';

function App() {
  const loadScript = (src, id, async = true) => {
    if (document.getElementById(id)) {
      console.log(`Script ${id} déjà chargé.`);
      return;
    }
    const script = document.createElement('script');
    script.src = src;
    script.id = id;
    script.async = async;
    document.body.appendChild(script);
    console.log(`Script ${id} chargé.`);
  };

  useEffect(() => {
    // Détecte si la page est dans un iframe.
    const inIframe = window.self !== window.top;

    // Ne charge ClickCease que si nous ne sommes PAS dans un iframe (donc en production réelle).
    if (!inIframe) {
      loadScript('https://ob.calderovian.com/i/8ebf25db54cbc10e911cf70b5c5ac68e.js', 'clickcease-prod-script');
    }
  }, []);

  const handleAcceptCookies = () => {
    console.log("Cookies acceptés : Mise à jour du consentement et chargement des trackers marketing/analytics...");
    
    // Mise à jour du consentement pour Google Consent Mode v2
    if (typeof window.gtag === 'function') {
      window.gtag('consent', 'update', {
        'ad_storage': 'granted',
        'analytics_storage': 'granted',
        'ad_user_data': 'granted',
        'ad_personalization': 'granted'
      });
      console.log("Google Consent Mode mis à jour à 'granted'.");
    }

    // Initialisation de PostHog
    initPostHog();
    posthog.capture('cookie_consent_accepted', { status: 'user_accepted' });
    
    // Chargement des scripts marketing/analytics
    loadScript('https://app.truconversion.com/ti-js/57513/67daa.js', 'truconversion-script');

    // Initialisation du Pixel Facebook
    const facebookPixelId = '4617421424968090';
    if (!window.fbq) {
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      
      window.fbq('init', facebookPixelId);
      window.fbq('track', 'PageView');
      console.log("Facebook Pixel initialisé.");
    }
  };

  return (
    <BrowserRouter>
      <CookieConsent onAccept={handleAcceptCookies} />
      <Routes>
        <Route path="/" element={<HomeLight />} />
        <Route path="/simulation" element={<FormPage />} /> {/* Nouvelle route */}
        <Route path="/rappel-expert" element={<HomeRetarget />} /> {/* Page de remarketing */}
        <Route path="/plan-epargne-retraite-per" element={<HomeLight />} />
        <Route path="/plan-epargne-retraite" element={<HomeLight />} />
        <Route path="/mentions-legales" element={<MentionsLegales />} />
        <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
        <Route path="/cgu" element={<CGU />} />
        <Route path="/cookies" element={<Cookies />} />
        <Route path="/merci" element={<Merci />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;